import * as dateFns from 'date-fns';

export default function getRelativeDateFromDateString(
  input: string | number | Date,
): string {
  return dateFns.formatDistance(new Date(input), new Date()) + ' ago';
}
